import { FC, FunctionComponent, SVGProps } from "react";

import styles from "./styles.module.scss";

interface Props {
    icon: FunctionComponent<SVGProps<SVGSVGElement>>;
    onClick?: () => void;
    size?: "sx" | "small" | "medium" | "large";
    color?: "primary" | "secondary";
}

const IconButton: FC<Props> = ({
    icon: Icon,
    onClick,
    size = "medium",
    color = "primary",
}) => {
    let iconSize: number;

    switch (size) {
        case "sx":
            iconSize = 10;
            break;
        case "small":
            iconSize = 12;
            break;
        case "large":
            iconSize = 24;
            break;
        case "medium":
        default:
            iconSize = 16;
            break;
    }

    return (
        <button
            onClick={onClick}
            className={`${styles.iconButton} ${styles[size]} ${styles[color]}`}
        >
            <Icon className={styles.icon} width={iconSize} height={iconSize} />
        </button>
    );
};

export default IconButton;
